import type { FindAllASTEntityValuesResponseType } from 'src/api/generated/touring/types';
import { mapTicketSalesAstEntityValueType } from './helpers';
import type { FindAllTicketSalesASTEntityValuesType } from './types';

export const mapFindAllTicketSalesASTEntityValuesResponseType = (
  api: FindAllASTEntityValuesResponseType
): FindAllTicketSalesASTEntityValuesType =>
  api.data.map(mapTicketSalesAstEntityValueType);
